import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TablePagination from '@mui/material/TablePagination'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import Button from '@mui/material/Button'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import '../../Styles/App/User/Profile.css'
import requests from '../../Components/AxiosCalls/AxiosAuth'
import DetailsContratos from './DetailsContratos'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		// backgroundColor: theme.palette.common.white,
		backgroundColor: '#BD7439',
		color: '#fff',
		textTransform: 'uppercase',
		fontWeight: '800',
		fontSize: window.screen.width <= 600 ? 13 : 15,
		border: 10,
	},
	[`&.${tableCellClasses.body}`]: {
		color: '#545454',
		padding: window.screen.width <= 600 ? 13 : null,
		fontSize: window.screen.width <= 600 ? 13 : 18,
		border: 0,
	},
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	'&:nth-of-type(odd)': {
		backgroundColor: theme.palette.action.hover,
		// backgroundColor: '#D7D1C4',
	},
	// hide last border
	'&:last-child td, &:last-child th': {
		border: 0,
	},
}))

const TableContratos = (props) => {
	const [_Contratos, setContratos] = React.useState([])
	const [_idContrato, setIdContrato] = useState(null)
	const [page, setPage] = React.useState(0)
	const [rowsPerPage, setRowsPerPage] = React.useState(5)
	const [openDetailContratos, setOpenDetailContratos] = useState(false)

	const handleOpenDetailContratos = (id) => {
		if (openDetailContratos === false) {
			setOpenDetailContratos(!openDetailContratos)
		} else {
			setOpenDetailContratos(!openDetailContratos)
			setIdContrato(null)
		}
	}
	const handleChangePage = (event, newPage) => {
		setPage(newPage)
	}

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(+event.target.value)
		setPage(0)
	}
	const getContratos = () => {
		requests
			.get('Contratos/ObtenerListaClienteMb', props.userId)
			.then((response) => {
				setContratos(response)
				setIdContrato(null)
			})
			.catch((error) => {
				console.log(error)
			})
	}
	const columns = [
		{
			id: 'folio',
			label: 'Folio',
			minWidth: window.screen.width <= 600 ? 45 : 80,
		},
		{
			id: 'descargar',
			label: 'Detalles',
			minWidth: window.screen.width <= 600 ? 65 : 100,
		},
	]

	useEffect(() => {
		getContratos()
	}, [])
	return (
		<div className=''>
			<Paper sx={{ width: '100%', overflow: 'hidden', boxShadow: 'none' }}>
				<TableContainer sx={{ maxHeight: 500 }}>
					<Table stickyHeader aria-label='sticky table'>
						<TableHead>
							<TableRow>
								{columns.map((column) => (
									<StyledTableCell
										key={column.id}
										align={column.align}
										style={{ minWidth: column.minWidth }}
									>
										<span>{column.label}</span>
									</StyledTableCell>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							{_Contratos
								.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
								.map((row) => {
									return (
										<StyledTableRow
											hover
											role='checkbox'
											tabIndex={-1}
											key={row.lngIdContrato}
											className='font-weight6'
										>
											<StyledTableCell>{row.txtNumContrato}</StyledTableCell>
											<StyledTableCell>
												<Button
													onClick={function () {
														handleOpenDetailContratos()
														setIdContrato(row.lngIdContrato)
													}}
													size='small'
													className='btn-table-Contratos'
													startIcon={<VisibilityOutlinedIcon />}
												>
													Ver Documentos
												</Button>
											</StyledTableCell>
										</StyledTableRow>
									)
								})}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[10, 25, 100]}
					component='div'
					count={_Contratos.length}
					rowsPerPage={rowsPerPage}
					page={page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			</Paper>
			{_idContrato !== null ? (
				<DetailsContratos
					open={openDetailContratos}
					onClose={handleOpenDetailContratos}
					idContrato={_idContrato}
					getRegistros={getContratos}
					setOpenLoadingScreen={props.setOpenLoadingScreen}
					setCloseLoadingScreen={props.setCloseLoadingScreen}
					setOpenSnackBar={props.setOpenSnackBar}
					setMessageSnackBar={props.setMessageSnackBar}
					setTypeSnackBar={props.setTypeSnackBar}
				/>
			) : null}
		</div>
	)
}

export default TableContratos
